<template>
  <div
    class="vheight InformationDetail"
    v-loading="loading"
    element-loading-text="数据正在加载中，请稍候"
  >
    <div
      class="container-boot"
      :style="{ height: 'calc(100%)' }"
      style="padding-right: 10px; padding-left: 10px"
    >
      <div class="panel-title">
        <div
          class="panel-type"
          :class="{ active: objType == 1 }"
          @click="handleTitle(1)"
        >
          <div class="icon">
            <i class="el-icon-office-building"></i>
          </div>
          <span class="title">物业企业</span>
        </div>
        <div
          class="panel-type"
          :class="{ active: objType == 2 }"
          @click="handleTitle(2)"
        >
          <div class="icon">
            <i class="el-icon-user"></i>
          </div>
          <span class="title">项目负责人</span>
        </div>
        <div
          class="panel-type"
          :class="{ active: objType == 3 }"
          @click="handleTitle(3)"
        >
          <div class="icon">
            <i class="el-icon-set-up"></i>
          </div>
          <span class="title">业委会成员</span>
        </div>
        <!-- <div
          class="panel-type"
          :class="{ active: objType == 4 }"
          @click="handleTitle(4)"
        >
          <div class="icon">
            <i class="el-icon-coffee"></i>
          </div>
          <span class="title">业主</span>
        </div> -->
        <div
          class="panel-type"
          :class="{ active: objType == 5 }"
          @click="handleTitle(5)"
        >
          <div class="icon">
            <i class="el-icon-coffee"></i>
          </div>
          <span class="title">业委会执行秘书</span>
        </div>
        <div
          class="panel-type"
          :class="{ active: objType == 6 }"
          @click="handleTitle(6)"
        >
          <div class="icon">
            <i class="el-icon-coffee"></i>
          </div>
          <span class="title">业主监事（会）</span>
        </div>
      </div>
      <el-tabs
        tab-position="left"
        @tab-click="getDetailByCode"
        v-model="infoType"
      >
        <el-tab-pane label="基本信息" name="1" class="basic">
          <div class="pane-title">
            <i class="el-icon-office-building"></i>
            <span>{{ title }}</span>
          </div>
          <div class="pane-content">
            <!--物业企业 基本信息-->
            <template v-if="objType == 1">
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('共有资金账户')"
              >
                <div class="panel-top">
                  {{
                    detail.RegComAccEaAreaCount + '/' + detail.EaAreaTotalCount
                  }}
                </div>
                <div class="panel-bottom">共有资金账户登记情况</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('信息公开率')"
              >
                <div class="panel-top">
                  {{
                    detail.PublicInfoDoneCount +
                    '/' +
                    detail.PublicInfoShouldCount
                  }}
                </div>
                <div class="panel-bottom">信息公开情况</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('在管面积㎡')"
              >
                <div class="panel-top">{{ detail.EaAreaTotalCount }}</div>
                <div class="panel-bottom">在管项目数</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('在管面积㎡')"
              >
                <div class="panel-top">
                  {{
                    detail.RealtyBuildTotalArea >= 0
                      ? Number(detail.RealtyBuildTotalArea).toFixed(2)
                      : detail.RealtyBuildArea
                      ? Number(detail.RealtyBuildArea).toFixed(2)
                      : 0
                  }}m²
                </div>
                <div class="panel-bottom">在管面积</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('通知公告响应率')"
              >
                <div class="panel-top">
                  {{
                    detail.ViewedNoticeCount +
                    '/' +
                    detail.ReceiveNoticeTotalCount
                  }}
                </div>
                <div class="panel-bottom">通知公告反映情况</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('满意度得分')"
              >
                <div class="panel-top">
                  {{ detail.EvaluateScore ? detail.EvaluateScore : '0' }}
                </div>
                <div class="panel-bottom">满意度得分</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('人员培训情况')"
              >
                <div class="panel-top">
                  {{ detail.EmplyeeTrainTotalCount + '' || '-' }}
                </div>
                <div class="panel-bottom">人员培训情况</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('安全检查情况')"
              >
                <div class="panel-top">
                  {{
                    detail.SecuritycheckQualifieCount +
                    '/' +
                    detail.SecuritycheckTotalCount
                  }}
                </div>
                <div class="panel-bottom">安全检查情况</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('反馈率')"
              >
                <div class="panel-top">
                  {{
                    !detail.EvaResRate || detail.EvaResRate == '-'
                      ? '-'
                      : `${(Number(detail.EvaResRate) * 100).toFixed(2)}%`
                  }}
                </div>
                <div class="panel-bottom">反馈率</div>
              </div>
              <div class="content-panel">
                <div class="panel-top">{{ detail.ReportFillCount }}</div>
                <div class="panel-bottom">统计填报情况</div>
              </div>
              <div class="content-panel">
                <div class="panel-top">
                  {{ Number(detail.TotalArea).toFixed(2) }}m²
                </div>
                <div class="panel-bottom">全国在管面积</div>
              </div>
              <div class="content-panel"></div>
            </template>
            <!--项目负责人 基本-->
            <template v-if="objType == 2">
              <div class="content-panel">
                <div class="panel-top">{{ detail.ManageName }}</div>
                <div class="panel-bottom">项目经理</div>
              </div>
              <div class="content-panel">
                <div class="panel-top">
                  {{ detail.EaAreaName || detail.eaAreaName }}
                </div>
                <div class="panel-bottom">物业项目</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('共有资金账户')"
              >
                <div class="panel-top">
                  {{ detail.IsRegComAcc ? '已登记' : '未登记' }}
                </div>
                <div class="panel-bottom">共有资金账户登记情况</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('信息公开率')"
              >
                <div class="panel-top">
                  {{
                    detail.RealPubInfoCount + '/' + detail.ShouldPubInfoCount
                  }}
                </div>
                <div class="panel-bottom">信息公开情况</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('在管面积㎡')"
              >
                <div class="panel-top">
                  {{
                    detail.RealtyBuildTotalArea >= 0
                      ? detail.RealtyBuildTotalArea
                      : detail.RealtyBuildArea
                      ? detail.RealtyBuildArea
                      : 0
                  }}m²
                </div>
                <div class="panel-bottom">在管面积</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('通知公告响应率')"
              >
                <div class="panel-top">
                  {{
                    detail.ViewedNoticeCount +
                    '/' +
                    detail.ReceiveNoticeTotalCount
                  }}
                </div>
                <div class="panel-bottom">通知公告反映情况</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('满意度得分')"
              >
                <div class="panel-top">
                  {{ detail.EvaluateScore ? detail.EvaluateScore : '0' }}
                </div>
                <div class="panel-bottom">满意度得分</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('人员培训情况')"
              >
                <div class="panel-top">
                  {{ detail.EmplyeeTrainTotalCount + '' || '-' }}
                </div>
                <div class="panel-bottom">人员培训情况</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('安全检查情况')"
              >
                <div class="panel-top">
                  {{
                    detail.SecuritycheckQualifieCount +
                    '/' +
                    detail.SecuritycheckTotalCount
                  }}
                </div>
                <div class="panel-bottom">安全检查情况</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('反馈率')"
              >
                <div class="panel-top">
                  {{
                    !detail.EvaResRate || detail.EvaResRate == '-'
                      ? '-'
                      : `${(Number(detail.EvaResRate) * 100).toFixed(2)}%`
                  }}
                </div>
                <div class="panel-bottom">反馈率</div>
              </div>
            </template>
            <!--业委会成员 基本-->
            <template v-if="objType == 3">
              <template v-if="detail.OwnerCommitteeMemberVO">
                <div class="content-panel">
                  <div class="panel-top">
                    {{ detail.OwnerCommitteeMemberVO.OwnerMemberName }}
                  </div>
                  <div class="panel-bottom">业委会成员</div>
                </div>
                <div class="content-panel">
                  <div class="panel-top">
                    {{ detail.OwnerCommitteeMemberVO.Division | getDivision }}
                  </div>
                  <div class="panel-bottom">分工</div>
                </div>
                <div class="content-panel">
                  <div class="panel-top">
                    {{ detail.OwnerCommitteeMemberVO.EaAreaName }}
                  </div>
                  <div class="panel-bottom">物业项目</div>
                </div>
                <div class="content-panel">
                  <div class="panel-top">
                    {{ detail.OwnerCommitteeMemberVO.OwnerTeamName }}
                  </div>
                  <div class="panel-bottom">业委会名称</div>
                </div>
                <div
                  class="content-panel"
                  @click="gutoComprehensiveList('人员培训情况')"
                >
                  <div class="panel-top">
                    {{ detail.EmplyeeTrainTotalCount + '' || '-' }}
                  </div>
                  <div class="panel-bottom">人员培训情况</div>
                </div>
                <div class="content-panel">
                  <div class="panel-top"></div>
                  <div class="panel-bottom"></div>
                </div>
              </template>
              <template v-else>
                <div class="content-panel">
                  <div class="panel-top">{{ detail.MasterName }}</div>
                  <div class="panel-bottom">业委会主任</div>
                </div>
                <div class="content-panel">
                  <div class="panel-top">{{ detail.EaAreaName }}</div>
                  <div class="panel-bottom">物业项目</div>
                </div>
                <div class="content-panel">
                  <div class="panel-top">{{ detail.OrgName }}</div>
                  <div class="panel-bottom">业委会名称</div>
                </div>
                <div
                  class="content-panel gotourl"
                  @click="gutoComprehensiveList('共有资金账户')"
                >
                  <div class="panel-top">
                    {{ detail.IsRegComAcc ? '已登记' : '未登记' }}
                  </div>
                  <div class="panel-bottom">共有资金账户登记情况</div>
                </div>
                <div
                  class="content-panel gotourl"
                  @click="gutoComprehensiveList('信息公开率')"
                >
                  <div class="panel-top">
                    {{
                      detail.RealPubInfoCount + '/' + detail.ShouldPubInfoCount
                    }}
                  </div>
                  <div class="panel-bottom">信息公开情况</div>
                </div>
                <div
                  class="content-panel gotourl"
                  @click="gutoComprehensiveList('通知公告响应率')"
                >
                  <div class="panel-top">
                    {{
                      detail.ViewedNoticeCount +
                      '/' +
                      detail.ReceiveNoticeTotalCount
                    }}
                  </div>
                  <div class="panel-bottom">通知公告反映情况</div>
                </div>
                <div
                  class="content-panel gotourl"
                  @click="gutoComprehensiveList('满意度得分')"
                >
                  <div class="panel-top">
                    {{ detail.EvaluateScore ? detail.EvaluateScore : '0' }}
                  </div>
                  <div class="panel-bottom">满意度得分</div>
                </div>
                <div
                  class="content-panel gotourl"
                  @click="gutoComprehensiveList('人员培训情况')"
                >
                  <div class="panel-top">
                    {{ detail.EmplyeeTrainTotalCount + '' || '-' }}
                  </div>
                  <div class="panel-bottom">人员培训情况</div>
                </div>
                <div
                  class="content-panel gotourl"
                  @click="gutoComprehensiveList('反馈率')"
                >
                  <div class="panel-top">
                    {{
                      !detail.EvaResRate || detail.EvaResRate == '-'
                        ? '-'
                        : `${(Number(detail.EvaResRate) * 100).toFixed(2)}%`
                    }}
                  </div>
                  <div class="panel-bottom">反馈率</div>
                </div>
              </template>
            </template>

            <!--业主 基本-->
            <template v-if="objType == 4">
              <div class="content-panel">
                <div class="panel-top">{{ peopleName }}</div>
                <div class="panel-bottom">业主姓名</div>
              </div>
              <div class="content-panel">
                <div class="panel-top">
                  {{ detail.EaAreaName || detail.eaAreaName }}
                </div>
                <div class="panel-bottom">物业项目</div>
              </div>
              <div class="content-panel">
                <div class="panel-top">{{ detail.ownerTeam || '暂无' }}</div>
                <div class="panel-bottom">业委会名称</div>
              </div>
            </template>
            <!--业委会秘书 基本-->
            <template v-if="objType == 5">
              <div class="content-panel">
                <div class="panel-top">{{ peopleName }}</div>
                <div class="panel-bottom">姓名</div>
              </div>

              <div class="content-panel">
                <div class="panel-top">
                  {{ detail.EaAreaName || detail.eaAreaName }}
                </div>
                <div class="panel-bottom">物业项目</div>
              </div>

              <div class="content-panel">
                <div class="panel-top">{{ detail.ownerTeam || '暂无' }}</div>
                <div class="panel-bottom">业委会名称</div>
              </div>

              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('人员培训情况')"
              >
                <div class="panel-top">
                  {{ detail.emplyeeTrainTotalCount + '' || '-' }}
                </div>
                <div class="panel-bottom">人员培训情况</div>
              </div>
            </template>
            <!--业委会监事 基本-->
            <template v-if="objType == 6">
              <div class="content-panel">
                <div class="panel-top">{{ peopleName }}</div>
                <div class="panel-bottom">姓名</div>
              </div>
              <div class="content-panel">
                <div class="panel-top">
                  {{ detail.EaAreaName || detail.eaAreaName || '--' }}
                </div>
                <div class="panel-bottom">物业项目</div>
              </div>
              <div class="content-panel">
                <div class="panel-top">{{ detail.ownerTeam || '暂无' }}</div>
                <div class="panel-bottom">业委会名称</div>
              </div>
              <div
                class="content-panel gotourl"
                @click="gutoComprehensiveList('人员培训情况')"
              >
                <div class="panel-top">
                  {{ detail.emplyeeTrainTotalCount + '' || '--' }}
                </div>
                <div class="panel-bottom">人员培训情况</div>
              </div>
            </template>
          </div>
        </el-tab-pane>
        <el-tab-pane label="良好信息" name="2">
          <div class="pane-title">
            <i class="el-icon-office-building"></i>
            <span>{{ title }}</span>
          </div>
          <div class="recognition">
            <!--物业企业 良好-->
            <template v-if="objType == 1">
              <div class="recognition-panel">
                <span>企业名称：</span>
                <span class="recognition-con">{{ detail.orgName }}</span>
              </div>
              <div class="recognition-panel" @click="gotuWellHealth(7)">
                <span>标准编制：</span>
                <span class="recognition-con">{{ detail.standard }}次</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotuWellHealth(1)">
                <span>表彰信息：</span>
                <span class="recognition-con">{{ detail.good }}次</span>
              </div>
              <!--              <div class="recognition-panel gotourl" @click="gotuWellHealth(3)">-->
              <!--                <span>绿色物业：</span>-->
              <!--                <span class="recognition-con">{{detail.green}}次</span>-->
              <!--              </div>-->
              <div class="recognition-panel gotourl" @click="gotuWellHealth(2)">
                <span>幸福小区：</span>
                <span class="recognition-con">{{ detail.happy }}次</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotuWellHealth(5)">
                <span>绿色物业星级评价：</span>
                <span class="recognition-con">{{ detail.star }}次</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotuWellHealth(4)">
                <span>绿色物业示范项目：</span>
                <span class="recognition-con">{{ detail.model }}次</span>
              </div>
              <div class="recognition-panel">
                <span>连续六个月前十次数：</span>
                <span class="recognition-con">{{ detail.top10 }}次</span>
              </div>
            </template>
            <!--项目负责人 良好-->
            <template v-if="objType == 2">
              <div class="recognition-panel">
                <span>物业项目：</span>
                <span class="recognition-con">{{ detail.eaAreaName }}</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotuWellHealth(1)">
                <span>表彰信息：</span>
                <span class="recognition-con">{{ detail.good }}次</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotuWellHealth(3)">
                <span>绿色物业：</span>
                <span class="recognition-con">{{ detail.green }}次</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotuWellHealth(2)">
                <span>幸福小区：</span>
                <span class="recognition-con">{{ detail.happy }}次</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotuWellHealth(5)">
                <span>绿色物业星级评价：</span>
                <span class="recognition-con">{{ detail.star }}次</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotuWellHealth(4)">
                <span>绿色物业示范项目：</span>
                <span class="recognition-con">{{ detail.model }}次</span>
              </div>
              <div class="recognition-panel">
                <span>连续六个月前十次数：</span>
                <span class="recognition-con">{{ detail.top10 }}次</span>
              </div>
            </template>
            <!--业委会成员 良好-->
            <template v-if="objType == 3">
              <template v-if="detail.OwnerCommitteeMemberVO">
                <div class="recognition-panel">
                  <span>业委会成员：</span>
                  <span class="recognition-con">{{
                    detail.OwnerCommitteeMemberVO.OwnerMemberName
                  }}</span>
                </div>
                <div class="recognition-panel">
                  <span>分工：</span>
                  <span class="recognition-con">{{
                    detail.OwnerCommitteeMemberVO.Division | getDivision
                  }}</span>
                </div>
                <div class="recognition-panel">
                  <span>物业项目：</span>
                  <span class="recognition-con">{{
                    detail.OwnerCommitteeMemberVO.EaAreaName
                  }}</span>
                </div>
                <div class="recognition-panel">
                  <span>业委会名称：</span>
                  <span class="recognition-con">{{
                    detail.OwnerCommitteeMemberVO.OwnerTeamName
                  }}</span>
                </div>
                <div class="recognition-panel" @click="gotuWellHealth(1)">
                  <span>表彰信息：</span>
                  <span class="recognition-con">{{ detail.good }}次</span>
                </div>
              </template>
              <template v-else>
                <div class="recognition-panel">
                  <span>业委会主任：</span>
                  <span class="recognition-con">{{
                    detail.masterName || '暂无'
                  }}</span>
                </div>
                <div class="recognition-panel">
                  <span>物业项目：</span>
                  <span class="recognition-con">{{ eaAreaName }}</span>
                </div>
                <div class="recognition-panel">
                  <span>业委会名称：</span>
                  <span class="recognition-con">{{
                    detail.ownerTeamName || '暂无'
                  }}</span>
                </div>
                <div
                  class="recognition-panel gotourl"
                  @click="gotuWellHealth(1)"
                >
                  <span>表彰信息：</span>
                  <span class="recognition-con">{{ detail.good }}次</span>
                </div>
                <div class="recognition-panel">
                  <span>连续六个月前十次数：</span>
                  <span class="recognition-con">{{ detail.top10 }}次</span>
                </div>
              </template>
            </template>
            <!--业主 良好-->
            <template v-if="objType == 4">
              <div class="recognition-panel">
                <span>业主姓名：</span>
                <span class="recognition-con">{{ peopleName }}</span>
              </div>
              <div class="recognition-panel">
                <span>物业项目：</span>
                <span class="recognition-con">{{ detail.eaAreaName }}</span>
              </div>
              <div class="recognition-panel">
                <span>业委会名称：</span>
                <span class="recognition-con">{{
                  detail.ownerTeamName || '暂无'
                }}</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotuWellHealth(1)">
                <span>表彰信息：</span>
                <span class="recognition-con">{{ detail.good }}次</span>
              </div>
            </template>
            <!--业委会秘书 良好-->
            <template v-if="objType == 5">
              <div class="recognition-panel">
                <span>姓名：</span>
                <span class="recognition-con">{{ peopleName }}</span>
              </div>
              <div class="recognition-panel">
                <span>物业项目：</span>
                <span class="recognition-con">{{ detail.eaAreaName }}</span>
              </div>
              <div class="recognition-panel">
                <span>业委会名称：</span>
                <span class="recognition-con">{{
                  detail.ownerTeamName || '暂无'
                }}</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotuWellHealth(1)">
                <span>表彰信息：</span>
                <span class="recognition-con">{{ detail.good }}次</span>
              </div>
            </template>
            <!--业委会监事 良好-->
            <template v-if="objType == 6">
              <div class="recognition-panel">
                <span>姓名：</span>
                <span class="recognition-con">{{ peopleName }}</span>
              </div>
              <div class="recognition-panel">
                <span>物业项目：</span>
                <span class="recognition-con">{{
                  detail.eaAreaName || '--'
                }}</span>
              </div>
              <div class="recognition-panel">
                <span>业委会名称：</span>
                <span class="recognition-con">{{
                  detail.ownerTeamName || '暂无'
                }}</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotuWellHealth(1)">
                <span>表彰信息：</span>
                <span class="recognition-con">{{ detail.good || 0 }}次</span>
              </div>
            </template>
          </div>
        </el-tab-pane>
        <el-tab-pane label="不良信息" name="3">
          <div class="bad-info">
            <div class="pane-title">
              <i class="el-icon-office-building"></i>
              <span>{{ title }}</span>
            </div>
            <!-- 物业企业 不良-->
            <template v-if="objType == 1">
              <div class="recognition-panel">
                <span>企业名称: </span>
                <span class="recognition-con">{{ detail.orgName }}</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotoUnhealthy(3)">
                <span>责令整改: </span>
                <span class="recognition-con"
                  >{{
                    detail.rectification && detail.rectification._Items.length
                  }}次</span
                >
              </div>
              <div class="recognition-panel gotourl" @click="gotoUnhealthy(1)">
                <span>行政处罚: </span>
                <span class="recognition-con"
                  >{{ detail.punish && detail.punish._Items.length }}次</span
                >
              </div>
              <div class="recognition-panel gotourl" @click="gotoUnhealthy(2)">
                <span>法院判决: </span>
                <span class="recognition-con"
                  >{{
                    detail.arbitration && detail.arbitration._Items.length
                  }}次</span
                >
              </div>
              <div class="recognition-panel gotourl">
                <span>连续六个月倒十次数: </span>
                <span class="recognition-con">{{ detail.last10 || 0 }}次</span>
              </div>
            </template>
            <!-- 项目负责人 不良-->
            <template v-if="objType == 2">
              <div class="recognition-panel">
                <span>物业项目: </span>
                <span class="recognition-con">{{ detail.eaAreaName }}</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotoUnhealthy(3)">
                <span>责令整改: </span>
                <span class="recognition-con"
                  >{{
                    detail.rectification && detail.rectification._Items.length
                  }}次</span
                >
              </div>
              <div class="recognition-panel gotourl" @click="gotoUnhealthy(1)">
                <span>行政处罚: </span>
                <span class="recognition-con"
                  >{{ detail.punish && detail.punish._Items.length }}次</span
                >
              </div>
              <div class="recognition-panel gotourl" @click="gotoUnhealthy(2)">
                <span>法院判决: </span>
                <span class="recognition-con"
                  >{{
                    detail.arbitration && detail.arbitration._Items.length
                  }}次</span
                >
              </div>
              <div class="recognition-panel gotourl">
                <span>连续六个月倒十次数: </span>
                <span class="recognition-con">{{ detail.last10 || 0 }}次</span>
              </div>
            </template>
            <!-- 业委会成员 不良-->
            <template v-if="objType == 3">
              <!--          不为null-->
              <template v-if="detail.OwnerCommitteeMemberVO">
                <div class="recognition-panel">
                  <span>业委会成员：</span>
                  <span class="recognition-con">{{
                    detail.OwnerCommitteeMemberVO.OwnerMemberName
                  }}</span>
                </div>
                <div class="recognition-panel">
                  <span>分工：</span>
                  <span class="recognition-con">{{
                    detail.OwnerCommitteeMemberVO.Division | getDivision
                  }}</span>
                </div>
                <div class="recognition-panel">
                  <span>物业项目：</span>
                  <span class="recognition-con">{{
                    detail.OwnerCommitteeMemberVO.EaAreaName
                  }}</span>
                </div>
                <div class="recognition-panel">
                  <span>业委会名称：</span>
                  <span class="recognition-con">{{
                    detail.OwnerCommitteeMemberVO.OwnerTeamName
                  }}</span>
                </div>
                <div class="recognition-panel" @click="gotoUnhealthy(3)">
                  <span>责令整改: </span>
                  <span class="recognition-con"
                    >{{
                      detail.rectification &&
                      detail.rectification._Items.length
                    }}次</span
                  >
                </div>
                <div class="recognition-panel" @click="gotoUnhealthy(1)">
                  <span>行政处罚: </span>
                  <span class="recognition-con"
                    >{{ detail.punish && detail.punish._Items.length }}次</span
                  >
                </div>
                <div class="recognition-panel" @click="gotoUnhealthy(2)">
                  <span>法院判决: </span>
                  <span class="recognition-con"
                    >{{
                      detail.arbitration && detail.arbitration._Items.length
                    }}次</span
                  >
                </div>
              </template>
              <template v-else>
                <div class="recognition-panel">
                  <span>业委会名称: </span>
                  <span class="recognition-con">{{
                    detail.ownerTeamName || '暂无'
                  }}</span>
                </div>
                <div class="recognition-panel">
                  <span>业委会主任: </span>
                  <span class="recognition-con">{{ detail.masterName }}</span>
                </div>
                <div class="recognition-panel">
                  <span>物业项目: </span>
                  <span class="recognition-con">{{ eaAreaName }}</span>
                </div>
                <div
                  class="recognition-panel gotourl"
                  @click="gotoUnhealthy(3)"
                >
                  <span>责令整改: </span>
                  <span class="recognition-con"
                    >{{
                      detail.rectification &&
                      detail.rectification._Items.length
                    }}次</span
                  >
                </div>
                <div
                  class="recognition-panel gotourl"
                  @click="gotoUnhealthy(1)"
                >
                  <span>行政处罚: </span>
                  <span class="recognition-con"
                    >{{ detail.punish && detail.punish._Items.length }}次</span
                  >
                </div>
                <div
                  class="recognition-panel gotourl"
                  @click="gotoUnhealthy(2)"
                >
                  <span>法院判决: </span>
                  <span class="recognition-con"
                    >{{
                      detail.arbitration && detail.arbitration._Items.length
                    }}次</span
                  >
                </div>
                <div class="recognition-panel gotourl">
                  <span>连续六个月倒十次数: </span>
                  <span class="recognition-con"
                    >{{ detail.last10 || 0 }}次</span
                  >
                </div>
              </template>
            </template>
            <!-- 业主 不良-->
            <template v-if="objType == 4">
              <div class="recognition-panel">
                <span>业主姓名: </span>
                <span class="recognition-con">{{ peopleName }}</span>
              </div>
              <div class="recognition-panel">
                <span>物业项目: </span>
                <span class="recognition-con">{{
                  detail.EaAreaName || detail.eaAreaName
                }}</span>
              </div>
              <div class="recognition-panel">
                <span>业委会名称: </span>
                <span class="recognition-con">{{
                  detail.ownerTeamName || '暂无'
                }}</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotoUnhealthy(3)">
                <span>责令整改: </span>
                <span class="recognition-con"
                  >{{
                    detail.rectification && detail.rectification._Items.length
                  }}次</span
                >
              </div>
              <div class="recognition-panel gotourl" @click="gotoUnhealthy(1)">
                <span>行政处罚: </span>
                <span class="recognition-con"
                  >{{ detail.punish && detail.punish._Items.length }}次</span
                >
              </div>
              <div class="recognition-panel gotourl" @click="gotoUnhealthy(2)">
                <span>法院判决: </span>
                <span class="recognition-con"
                  >{{
                    detail.arbitration && detail.arbitration._Items.length
                  }}次</span
                >
              </div>
            </template>
            <!-- 业委会秘书 不良-->
            <template v-if="objType == 5">
              <div class="recognition-panel">
                <span>姓名: </span>
                <span class="recognition-con">{{ peopleName }}</span>
              </div>
              <div class="recognition-panel">
                <span>物业项目: </span>
                <span class="recognition-con">{{
                  detail.EaAreaName || detail.eaAreaName
                }}</span>
              </div>
              <div class="recognition-panel">
                <span>业委会名称: </span>
                <span class="recognition-con">{{
                  detail.ownerTeamName || '暂无'
                }}</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotoUnhealthy(1)">
                <span>行政处罚: </span>
                <span class="recognition-con"
                  >{{ detail.punish && detail.punish._Items.length }}次</span
                >
              </div>
            </template>
            <!-- 业委会监事 不良-->
            <template v-if="objType == 6">
              <div class="recognition-panel">
                <span>姓名: </span>
                <span class="recognition-con">{{ peopleName }}</span>
              </div>
              <div class="recognition-panel">
                <span>物业项目: </span>
                <span class="recognition-con">{{
                  detail.EaAreaName || detail.eaAreaName || '--'
                }}</span>
              </div>
              <div class="recognition-panel">
                <span>业委会名称: </span>
                <span class="recognition-con">{{
                  detail.ownerTeamName || '暂无'
                }}</span>
              </div>
              <div class="recognition-panel gotourl" @click="gotoUnhealthy(1)">
                <span>行政处罚: </span>
                <span class="recognition-con"
                  >{{
                    (detail.punish && detail.punish._Items.length) || 0
                  }}次</span
                >
              </div>
            </template>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- <div class="PublicInformationDetail-footer">
      <ps-close></ps-close>
    </div>-->
  </div>
</template>
<script>
import { CreditInformationController } from '@/service/PublicCreditInformation/CreditInformationController.js';
import { headerredraw } from '@/mixin/headerredraw';
import { mapState } from 'vuex';
import TemplateCom from '@/page/SafeProduction/SafeProductionDatil/template';
export default {
  components: { TemplateCom },
  props: {},
  mixins: [headerredraw],
  data() {
    return {
      activeName: 'first',
      infoTypeOptions: [
        {
          value: '1',
          label: '基本信息',
        },
        {
          value: '2',
          label: '良好信息',
        },
        {
          value: '3',
          label: '不良信息',
        },
      ],
      detail: {},
      title: '',

      objType: 1,
      infoType: '1',
      columnLabel: '',
      code: '',
      eaAreaCode: '',
      nickName: '',
      orgName: '',
      eaAreaName: '',
      phoneNum: '',
      UniqID: '',
      peopleName: '', // 良好信息 不良信息
      certificate: '', // 不良信息  身份证号
      keyId: '', // 良好信息 不良信息
      loading: false,
    };
  },
  computed: { ...mapState(['token', 'userInfo', 'InformationManagerData']) },
  created() {
    this.CreditInformationController = new CreditInformationController();
    this.$set(this, 'detail', this.InformationManagerData);
    this.objType = this.$route.query.objType;
    this.infoType = String(this.$route.query.infoType);
    // this.columnLabel = decodeURI(this.$route.query.columnLabel);// 表头标题
    this.code = this.$route.query.code;
    this.eaAreaCode = this.$route.query.eaAreaCode;
    this.nickName = decodeURIComponent(this.$route.query.nickName || '');
    this.orgName = decodeURIComponent(this.$route.query.orgName || '');
    this.eaAreaName = decodeURIComponent(this.$route.query.eaAreaName || '');
    this.UniqID = this.$route.query.UniqID || '';
    this.phoneNum = this.$route.query.phoneNum || ''; // 项目经理phone
    // 良好信息 不良信息
    this.peopleName = decodeURIComponent(this.$route.query.peopleName || '');
    this.certificate = this.$route.query.certificate || '';
    this.keyId = this.$route.query.keyId || '';
  },
  mounted() {
    this.getDetailByCode();
  },
  infoType(val) {
    if (val) {
      this.getDetailByCode();
    }
  },
  filters: {
    getDivision(val) {
      let divisionName = '';
      switch (val) {
        case 1:
          divisionName = '主任';
          break;
        case 2:
          divisionName = '副主任';
          break;
        case 3:
          divisionName = '委员';
          break;
        case 4:
          divisionName = '候补委员';
          break;
      }
      return divisionName;
    },
    getProbability(num1, num2) {
      if (num1 == 0 || num2 == 0) {
        return 0;
      } else {
        return ((parseFloat(num1) / parseFloat(num2)) * 100).toFixed(2);
      }
    },
  },
  methods: {
    //空数据处理
    formatter(row, column, cellValue, index) {
      return cellValue === null || cellValue === '' ? '--' : cellValue;
    },
    handleTitle(val) {
      this.objType = val;
      this.$router.push({
        name: 'InformationManager',
        query: { objType: this.objType },
      });
    },
    searchKeyWord() {},

    showPara() {},
    getDetailByCode() {
      this.loading = true;
      if (this.objType == 2) {
        if (this.infoType == 1) {
          this.$set(this, 'detail', this.InformationManagerData);
          // 获取项目经理基本信息
          this.CreditInformationController.newGetManageBaseInfo(this.UniqID)
            .then((res) => {
              this.loading = false;
              if (Object.keys(res).length > 0) {
                this.detail = res;
                this.title = res.EaAreaName;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        } else {
          //获取项目经理良好 不良好信息
          this.CreditInformationController.GetBehaviorDetailByManger(
            this.eaAreaCode,
            this.infoType - 1
          )
            .then((res) => {
              this.loading = false;
              if (Object.keys(res).length > 0) {
                this.detail = res;
                this.title = res.eaAreaName;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        }
      } else if (this.objType == 3) {
        if (this.infoType == 1) {
          this.$set(this, 'detail', this.InformationManagerData);
          //获取业委会基本信息
          // if (this.keyId) {
          //   //uniqID不为空
          this.CreditInformationController.newGetOwnerTeamMasterBaseInfo(
            this.UniqID
          )
            .then((res) => {
              this.loading = false;
              if (Object.keys(res).length > 0) {
                this.detail = res;
                this.title = res.EaAreaName;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
          // } else {
          //   //uniqID为null
          //   this.CreditInformationController.GetOwnerTeamMemberBaseInfo(
          //     this.peopleName,
          //     this.eaAreaCode
          //   )
          //     .then((res) => {
          //       if (Object.keys(res).length > 0) {
          //         this.detail = res;
          //         if (res.OwnerCommitteeMemberVO) {
          //           this.eaAreaName = res.OwnerCommitteeMemberVO.EaAreaName;
          //           this.title = res.OwnerCommitteeMemberVO.EaAreaName;
          //         }
          //       }
          //     })
          //     .catch((error) => {
          //       this.$message({
          //         type: 'error',
          //         message: error,
          //       });
          //     });
          // }
        } else {
          //获取业委会良好 不良好信息
          if (this.keyId) {
            //uniqID不为null
            this.CreditInformationController.GetBehaviorDetailByDirector(
              this.eaAreaCode,
              this.infoType - 1
            )
              .then((res) => {
                this.loading = false;
                if (Object.keys(res).length > 0) {
                  this.detail = res;
                  this.eaAreaName = res.eaAreaName;
                  this.title = res.ownerTeamName;
                }
              })
              .catch((error) => {
                this.loading = false;
                this.$message({
                  type: 'error',
                  message: error,
                });
              });
          } else {
            //uniqID为null
            this.CreditInformationController.GetBehaviorDetailByMember(
              this.peopleName,
              this.eaAreaCode,
              this.infoType - 1
            )
              .then((res) => {
                this.loading = false;
                if (Object.keys(res).length > 0) {
                  this.detail = res;
                  if (res.OwnerCommitteeMemberVO) {
                    this.eaAreaName = res.OwnerCommitteeMemberVO.EaAreaName;
                    this.title = res.OwnerCommitteeMemberVO.OwnerTeamName;
                  }
                }
              })
              .catch((error) => {
                this.loading = false;
                this.$message({
                  type: 'error',
                  message: error,
                });
              });
          }
        }
      } else if (this.objType == 4) {
        //业主
        if (this.infoType == 1) {
          this.CreditInformationController.GetBasicDetailByOwner(
            4,
            this.peopleName,
            this.eaAreaCode
          )
            .then((res) => {
              this.loading = false;
              if (Object.keys(res).length > 0) {
                this.detail = res;
                this.title = res.eaAreaName;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        } else {
          this.CreditInformationController.GetBehaviorDetailByOwner(
            this.peopleName,
            this.certificate,
            this.eaAreaCode,
            this.infoType - 1
          )
            .then((res) => {
              this.loading = false;
              if (Object.keys(res).length > 0) {
                this.detail = res;
                this.title = res.eaAreaName;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        }
      } else if (this.objType == 1) {
        if (this.infoType == 1) {
          this.$set(this, 'detail', this.InformationManagerData);
          //企业基本信息
          this.CreditInformationController.newGetBasicInformation(this.code)
            .then((res) => {
              this.loading = false;
              if (Object.keys(res).length > 0) {
                this.detail = res;
                this.title = res.OrgName;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        } else {
          //企业良好 不良好信息
          this.CreditInformationController.GetBehaviorDetail(
            this.code,
            this.infoType - 1
          )
            .then((res) => {
              this.loading = false;
              if (Object.keys(res).length > 0) {
                this.detail = res;
                this.title = res.orgName;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        }
      } else if (this.objType == 5) {
        if (this.infoType == 1) {
          this.CreditInformationController.GetBasicDetailByOwner(
            5,
            this.peopleName,
            this.eaAreaCode
          )
            .then((res) => {
              this.loading = false;
              if (Object.keys(res).length > 0) {
                this.detail = res;
                this.title = res.eaAreaName;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        } else {
          this.CreditInformationController.GetBehaviorDetailBySecretary(
            this.keyId,
            this.infoType - 1
          )
            .then((res) => {
              this.loading = false;
              if (Object.keys(res).length > 0) {
                this.detail = res;
                this.title = res.eaAreaName;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        }
      } else if (this.objType == 6) {
        if (this.infoType == 1) {
          this.CreditInformationController.GetBasicDetailBySupervisor(
            this.eaAreaCode,
            this.peopleName
          )
            .then((res) => {
              this.loading = false;
              if (Object.keys(res).length > 0) {
                this.detail = res;
                this.title = res.eaAreaName;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        } else {
          this.CreditInformationController.GetBehaviorDetailBySupervisor(
            this.keyId,
            this.infoType - 1
          )
            .then((res) => {
              this.loading = false;
              if (Object.keys(res).length > 0) {
                this.detail = res;
                this.title = res.eaAreaName;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: error,
              });
            });
        }
      }
    },
    // 满意度得分 满意度排名 反馈率 在管面积 共有资金账户 登记共有资金账户 信息公开率 人员培训情况 通知公告响应率 安全检查情况
    gutoComprehensiveList(columnLabel) {
      if (
        this.objType != 1 &&
        (columnLabel == '通知公告响应率' || columnLabel == '安全检查情况')
      ) {
        this.$router.push({
          name: 'comprehensiveDetailsList',
          query: {
            objType: this.objType,
            infoType: this.infoType,
            columnLabel: encodeURIComponent(columnLabel),
            code: this.code || '',
            eaAreaCode: this.eaAreaCode || '',
            orgName: encodeURIComponent(this.orgName || ''),
            eaAreaName: encodeURIComponent(this.eaAreaName || ''),
            peopleName: encodeURIComponent(this.peopleName || ''),
            phoneNum: this.phoneNum || '', // 项目经理phone
            nickName: encodeURIComponent(this.nickName || ''),
          },
        });
      } else {
        this.$router.push({
          name: 'comprehensiveList',
          query: {
            objType: this.objType,
            infoType: this.infoType,
            columnLabel: encodeURIComponent(columnLabel),
            code: this.code || '',
            eaAreaCode: this.eaAreaCode || '',
            orgName: encodeURIComponent(this.orgName || ''),
            eaAreaName: encodeURIComponent(this.eaAreaName || ''),
            peopleName: encodeURIComponent(this.peopleName || ''),
            phoneNum: this.phoneNum || '', // 项目经理phone
            nickName: encodeURIComponent(this.nickName || ''),
          },
        });
      }
    },
    // 良好信息 '绿色物业' || '幸福小区' || '绿色物业星级评价' || '绿色物业示范项目' || '表彰信息'
    gotuWellHealth(columnLabelType) {
      let columnLabel = '';
      switch (columnLabelType) {
        case 1:
          columnLabel = '表彰信息';
          break;
        case 2:
          columnLabel = '幸福小区';
          break;
        case 3:
          columnLabel = '绿色物业';
          break;
        case 4:
          columnLabel = '绿色物业示范项目';
          break;
        case 5:
          columnLabel = '绿色物业星级评价';
          break;
        case 7:
          columnLabel = '标准编制';
          break;
        default:
          columnLabel = '良好信息';
      }
      this.$router.push({
        name: 'comprehensiveList',
        query: {
          objType: this.objType,
          infoType: this.infoType,
          columnLabel: encodeURIComponent(columnLabel),
          code: this.code || '',
          eaAreaCode: this.eaAreaCode || '',
          columnLabelType: columnLabelType,
          peopleName: encodeURIComponent(this.peopleName || ''),
          certificate: this.certificate || '',
          keyId: this.keyId || '',
        },
      });
    },
    // 不良信息 '责令整改' || '行政处罚' || '法院判决'
    gotoUnhealthy(columnLabelType) {
      let columnLabel = '';
      switch (columnLabelType) {
        case 1:
          columnLabel = '行政处罚';
          break;
        case 2:
          columnLabel = '法院判决';
          break;
        case 3:
          columnLabel = '责令整改';
          break;
        default:
          columnLabel = '不良信息';
      }
      this.$router.push({
        name: 'comprehensiveList',
        query: {
          objType: this.objType,
          infoType: this.infoType,
          columnLabel: encodeURIComponent(columnLabel),
          code: this.code || '',
          eaAreaCode: this.eaAreaCode || '',
          columnLabelType: columnLabelType,
          peopleName: encodeURIComponent(this.peopleName || ''),
          certificate: this.certificate || '',
          keyId: this.keyId || '',
        },
      });
    },
  },
};
</script>
<style lang="scss">
.el-tabs--border-card > .el-tabs__content {
  padding: 0px;
}

.InformationDetail {
  .el-tabs__content {
    padding: 0px;
  }
}
</style>
<style lang="scss" scoped>
.PublicInformationDetail {
  height: 100%;

  .basInfo-table {
    overflow: auto;

    .row {
      margin-right: 0;
      margin-left: 0;

      @media screen and (max-width: 992px) {
        flex-wrap: wrap !important;
      }

      .col-define {
        font-size: 14px;
        line-height: 42px;
        min-width: 150px;
        overflow: hidden;
        color: #666;
        border-bottom: 1px solid #e2e2e2;

        .col-chld {
          display: inline-block;
          width: 25%;

          & > div:nth-child(1) {
            display: inline-block;
            width: 30%;
            vertical-align: top;
          }

          & > div:nth-child(2) {
            display: inline-block;
            width: 70%;
          }
        }
      }

      .col-define:nth-child(2n) {
        flex: 1;
        border-right: 1px dotted #e2e2e2;
        padding-left: 24px;
      }

      .col-define:nth-child(2n-1) {
        text-align: right;
      }

      .col-tips {
        border-right: 1px dotted #e2e2e2;
      }
    }
  }

  .PublicInformationDetail-footer {
    text-align: right;
    margin: 20px;
  }
}

.InformationDetail {
  width: 100%;
  box-sizing: border-box;

  .header-seacher {
    @media screen and (max-width: 992px) {
      min-width: 0 !important;
      overflow-x: scroll;
    }
  }

  .gotourl {
    cursor: pointer;
  }

  .el-tabs__content {
    .pane-title {
      font-size: 20px;
      border-bottom: 1px solid;
      padding: 10px;
    }

    .recognition-con {
      color: rgb(140, 78, 127);
    }

    .el-tabs__item:hover {
      color: rgb(140, 78, 127) !important;
      cursor: pointer;
    }

    .el-tabs__item.is-active {
      color: rgb(140, 78, 127) !important;
    }

    .el-tabs__active-bar {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 2px;
      background-color: rgb(140, 78, 127) !important;
    }

    .recognition-panel {
      padding: 10px 0;
      padding-left: 20px;
    }

    .pane-content {
      padding: 20px 0;
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      justify-content: space-between;

      .content-panel {
        width: 30%;
        background: rgb(245, 245, 245);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 80px;
        margin-bottom: 20px;

        .panel-top {
          font-size: 18px;
          color: red;
        }
      }
    }
  }

  .panel-title {
    display: flex;
    justify-content: space-between;

    .active {
      color: rgb(140, 78, 127);
    }

    .panel-type {
      width: 18%;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: whitesmoke;

      .icon {
        font-size: 25px;
        padding-right: 10px;
      }

      .title {
        font-weight: bold;
      }
    }
  }

  .recognition {
    .recognition-panel {
      padding: 10px 0;
      padding-left: 20px;
    }
  }

  .search {
    padding: 15px 0;
    display: flex;
    align-items: center;

    .el-input__inner {
      background: rgb(140, 78, 127) !important;
      background-color: rgb(140, 78, 127) !important;
    }

    .search-input {
      flex: 1;

      .el-input {
        input {
          background: rgb(140, 78, 127) !important;
        }
      }
    }

    .search-select {
      .el-select {
        input {
          background-color: rgb(140, 78, 127) !important;
        }
      }
    }
  }

  .function {
    min-width: 400px;
  }

  .container-boot {
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    transition: height 0.3s;

    .container-header {
      width: 100%;
      padding-top: 10px;
      box-sizing: border-box;
    }

    .grid {
      height: calc(100% - 150px);
    }
  }

  .footer {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 10px;

    .fun {
      font-size: 14px;
      color: #409eff;
      cursor: pointer;

      .delete {
        margin-left: 20px;
      }
    }
  }
}
</style>
